import { useCreation } from "ahooks";
import { useEventsource } from "./useEventsource";
export function useDataload(factory, deps) {
  var dataload = useCreation(function () {
    var ins = factory();
    ins.get();
    return ins;
  }, deps);
  return useEventsource(dataload);
}